import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzProgressModule } from 'ng-zorro-antd/progress';
 
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { CardFishboneComponent } from './card-fishbone.component';
import { NzIconModule } from 'ng-zorro-antd/icon'; 

const COMPONENTS = [CardFishboneComponent];

@NgModule({
  imports: [CommonModule, NzProgressModule,NzAvatarModule,NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardFishboneModule {}
